import { setCookie } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/types';

export const COOKIE_LIFETIME_IN_DAYS_LONG = 360;

const MS_PER_DAY = 86_400_000;
/** 360 days in milliseconds */
export const SHARED_COOKIE_LIFETIME = COOKIE_LIFETIME_IN_DAYS_LONG * MS_PER_DAY;
export const SHARED_COOKIE_DOMAIN = `.${process.env.SHARED_DOMAIN}`;

const SPLIT_SIZE = -2;

export const getSharedCookieOptions = (
  expires: Date = new Date(Date.now() + SHARED_COOKIE_LIFETIME),
  domain: string = SHARED_COOKIE_DOMAIN,
): OptionsType => ({ domain, expires, sameSite: 'none', secure: true });

export const getDefaultCookieDomain = (): string => window?.location?.hostname?.split('.')?.slice(SPLIT_SIZE)?.join('.');

export const setCookieWithSameSiteNoneSecure = (key: string, value: string, cookieOpts?: OptionsType) => {
  const cookieOptions: OptionsType = { ...cookieOpts, sameSite: 'none', secure: true };
  setCookie(key, value, cookieOptions);
};
